export const Sort = {
  newest: 'newest',
  highestRating: 'highestRating',
  lowestRating: 'lowestRating',
  votesMost: 'votesMost',
  votesLeast: 'votesLeast',
  includesImg: 'includesImg',
};

export const SizePurchased = {
  xxs: 'XXS',
  xs: 'XS',
  s: 'S',
  m: 'M',
  l: 'L',
  xl: 'XL',
  xxl: 'XXL',
  oneX: '1X',
  twoX: '2X',
  threeX: '3X',
  fourX: '4X',
};

export const CustomerHeight = {
  underFourFootSix: "Under 4'6",
  fourFootsixToFiveFoot: "4'6 to 5'",
  fiveFootToFiveFootSix: "5' to 5'6",
  fiveFootSixToSixFoot: "5'6 to 6'",
  sixFootToSixFootSix: "6' to 6'6",
  overSixFootSix: "Over 6'6",
};

export const CustomerWeight = {
  below100: 'Below 100lbs',
  max125: '101-125lbs',
  max145: '126-145lbs',
  max165: '146-165lbs',
  max185: '146-165lbs',
  max200: '186-200lbs',
  max220: '201-220lbs',
  over220: 'Over 220lbs',
};

//apparel body type
export const BodyType = {
  triangle: 'Triangle (Wider in the Hips)',
  invertedTriangle: 'Inverted Triangle (Wider in the Chest)',
  rectangle: 'Rectangle (Straight from Chest to Hip)',
  oval: 'Oval (Round Through the Mid-Section)',
  hourglass: 'Hour Glass (Thin Through the Mid-Section)',
};

//bags body type
export const BodyBuild = {
  petite: 'Petite (shorter and/or smaller than most)',
  average: 'Average',
  big: 'Big and Tall (taller and/or larger than most)',
};

//bottoms body type
export const BodyTypeBottoms = {
  wideHips: 'Wider in the Hips',
  smallHips: 'Smaller in the Hips',
  highWaist: 'High Waisitline',
  shortWaist: 'Short Waistline',
  longLegs: 'Long Legs',
  shortLegs: 'Short Legs',
};

export const ReviewFilters = {
  sizePurchased: 'Size Purchased',
  sizeOrdered: 'Size Ordered',
  customerHeight: 'Customer Height', //for adults
  customerWeight: 'Customer Weight', //for adults
  customerBodyType: 'Customer Body Type',
  bodyType: 'Body Type',
  bodyShape: 'Body Shape',
  height: 'Height', //for kids
  weight: 'Weight', //for kids
};

export const KidsWeight = {
  under40: 'Below 40lbs',
  under60: '41-60lbs',
  under80: '61-80lb',
  under100: '81-100lb',
  under120: '101-120lbs',
  over120: 'Over 120lbs',
};

export const KidsHeight = {
  underThreeSix: "Under 3'6",
  threeSixToFourFoot: "3'6 to 4'",
  fourFootToFourSix: "4' to 4'6",
  fourSixToFiveFoot: "4'6 to 5'",
  fiveFootToFiveSix: "5' to 5'6",
  overFiveSix: "Over 5'6",
};

export const YotpoTags = {
  allpa: 'YCRF_Allpa',
  packs: 'YCRF_PacksBags',
  kidsInsulation: 'YCRF_KidsInsulation',
  fugeo: 'YCRF_Fuego',
  generalInsulation: 'YCRF_Insulation',
  apparel: 'YCRF_GenApparel',
  bottoms: 'YCRF_Bottoms',
};
